import _asyncToGenerator from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/wwwroot/dealer-web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import 'element-ui/lib/theme-chalk/display.css';
import { mapActions } from 'vuex';
import { listDealerUserOrganization, bindOrganization } from '@/api/organization.js';
import { sendCode } from '@/api/global.js';
import util from '@/libs/util.js';
import { clearMenu } from '@/menu';
import ForgetPasswordComponents from './components/forget/index.vue';
import { listDealerUserManufacturer } from '@/api/manufacturer.js';
export default {
  components: {
    ForgetPasswordComponents: ForgetPasswordComponents
  },
  mixins: [],
  data: function data() {
    var checkPhone = function checkPhone(rule, value, callback) {
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else {
        var reg = /^1[0123456789]\d{9}$/;

        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('请输入正确的手机号'));
        }
      }
    };

    return {
      pageId: 'login',
      loginStatus: false,
      uid: 0,
      loginLoading: false,
      sendCodeLoading: false,
      loginMethod: 'PASSWORD',
      sendCodeCD: 0,
      organizationList: [],
      // 组织列表
      loginAgree: false,
      loginByMobileForm: {
        username: '',
        code: ''
      },
      loginByMobileFormRules: {
        username: [{
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        }, {
          validator: checkPhone,
          trigger: 'blur'
        }],
        code: [{
          required: true,
          message: '请输入短信码',
          trigger: 'blur'
        }]
      },
      loginByPasswordForm: {
        username: '',
        password: ''
      },
      loginByPasswordFormRules: {
        username: [{
          required: true,
          message: '请输入手机号码',
          trigger: 'blur'
        }, {
          validator: checkPhone,
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: '请输入密码',
          trigger: 'blur'
        }]
      },
      loginTitle: '',
      profile: {}
    };
  },
  mounted: function mounted() {
    var that = this;
    this.logout();
    that.loginTitle = process.env.VUE_APP_TITLE || 'D2Admin';
    that.loginStatus = !!util.cookies.get('token');
  },
  beforeDestroy: function beforeDestroy() {},
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions('d2admin/account', ['login', 'logout', 'loginByMobile'])), mapActions('d2admin/db', ['database', 'databaseClear'])), {}, {
    /**
     * @description 接收选择一个用户快速登录的事件
     * @param {Object} user 用户信息
     */
    handleUserBtnClick: function handleUserBtnClick(user) {
      this.formLogin.username = user.username;
      this.formLogin.password = user.password;
      this.submit();
    },
    loginMethodChange: function loginMethodChange(val) {
      var that = this;
      that.loginMethod = val;
      that.$nextTick(function () {
        if (that.$refs.loginByMobileForm) {
          that.$refs.loginByMobileForm.clearValidate();
        }

        if (that.$refs.loginByPasswordForm) {
          that.$refs.loginByPasswordForm.clearValidate();
        }
      });
    },

    /**
     * @description 账号密码登录
     */
    loginByPasswordFormSubmit: function loginByPasswordFormSubmit() {
      var _this = this;

      var that = this;

      if (!that.loginAgree) {
        that.$message.error('必须同意客户使用规范内容及相关协议');
        return;
      }

      that.$refs.loginByPasswordForm.validate(function (valid, err) {
        if (valid) {
          that.loginLoading = true;
          that.login(that.loginByPasswordForm).then( /*#__PURE__*/function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
              var profile;
              return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                  switch (_context.prev = _context.next) {
                    case 0:
                      profile = _objectSpread(_objectSpread({}, res), {}, {
                        organizationId: 0,
                        organizationName: null
                      });
                      that.profile = profile; // 重定向对象不存在则返回顶层路径
                      // this.$router.replace(this.$route.query.redirect || '/')

                      that.uid = res.uid;
                      that.loginStatus = true;
                      that.loadOrganization();

                    case 5:
                    case "end":
                      return _context.stop();
                  }
                }
              }, _callee);
            }));

            return function (_x) {
              return _ref.apply(this, arguments);
            };
          }()).catch(function (e) {}).finally(function (e) {
            that.loginLoading = false;
          });
        } else {
          // 登录表单校验失败
          if (!_this.formLogin.username || !_this.formLogin.password) {
            _this.$message.error('请输入用户名/密码');
          }
        }
      });
    },

    /**
     * @description 手机短信码登录
     */
    loginByMobileFormSubmit: function loginByMobileFormSubmit() {
      var that = this;
      that.loginByMobileFormRules.code[0].required = true;

      if (!that.loginAgree) {
        that.$message.error('必须同意客户使用规范内容及相关协议');
        return;
      }

      that.$refs.loginByMobileForm.validate(function (valid, err) {
        if (valid) {
          that.loginByMobile(that.loginByMobileForm).then(function (res) {
            var profile = _objectSpread(_objectSpread({}, res), {}, {
              organizationId: 0,
              organizationName: null
            });

            that.profile = profile; // 重定向对象不存在则返回顶层路径
            // this.$router.replace(this.$route.query.redirect || '/')

            that.uid = res.uid;
            that.loginStatus = true;
            that.loadOrganization();
          }).finally(function (e) {
            that.loginLoading = false;
          });
        } else {// 登录表单校验失败
        }
      });
    },
    loadOrganization: function loadOrganization() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var that;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                that = _this2;
                listDealerUserOrganization().then( /*#__PURE__*/function () {
                  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
                    var db;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            that.organizationList = res.list;

                            if (res.list.length === 0) {
                              that.$message.error('未绑定任何组织');
                              that.logOut();
                            }

                            _context2.next = 4;
                            return _this2.database({
                              user: true
                            });

                          case 4:
                            db = _context2.sent;
                            that.profile.organizationList = res.list;
                            db.set('profile', that.profile).write();

                            if (that.organizationList.length === 1) {
                              that.organizationClick(that.organizationList[0]);
                            } else {
                              that.pageId = 'organizations';
                            }

                          case 8:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x2) {
                    return _ref2.apply(this, arguments);
                  };
                }());

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    organizationClick: function organizationClick(row) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var that, db;
        return regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                that = _this3;
                _context6.next = 3;
                return _this3.database({
                  user: true
                });

              case 3:
                db = _context6.sent;
                bindOrganization({
                  organization_id: row.id
                }).then( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(res) {
                    return regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            listDealerUserManufacturer().then( /*#__PURE__*/function () {
                              var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(res2) {
                                var findRow, profile;
                                return regeneratorRuntime.wrap(function _callee4$(_context4) {
                                  while (1) {
                                    switch (_context4.prev = _context4.next) {
                                      case 0:
                                        if (!(res2.list.length === 0)) {
                                          _context4.next = 5;
                                          break;
                                        }

                                        that.$message.error('未绑定经销商');
                                        that.logOut();
                                        _context4.next = 20;
                                        break;

                                      case 5:
                                        findRow = res2.list.find(function (item) {
                                          return item.show_status === true && (item.examine_status === 0 || item.examine_status === 3);
                                        });

                                        if (!findRow) {
                                          _context4.next = 18;
                                          break;
                                        }

                                        profile = that.profile;
                                        profile.organizationId = res.organizationId;
                                        profile.organizationName = res.organizationName;
                                        db.set('profile', profile).write();
                                        that.profile = profile;
                                        _context4.next = 14;
                                        return that.$store.dispatch('d2admin/user/set', res, {
                                          root: true
                                        });

                                      case 14:
                                        clearMenu();

                                        _this3.$router.replace(_this3.$route.query.redirect || '/');

                                        _context4.next = 20;
                                        break;

                                      case 18:
                                        that.$message.error('已绑定的经销商被禁用，无法登录');
                                        that.logOut();

                                      case 20:
                                      case "end":
                                        return _context4.stop();
                                    }
                                  }
                                }, _callee4);
                              }));

                              return function (_x4) {
                                return _ref4.apply(this, arguments);
                              };
                            }());

                          case 1:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  }));

                  return function (_x3) {
                    return _ref3.apply(this, arguments);
                  };
                }()).catch(function (e) {});

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    sendSmsCode: function sendSmsCode() {
      var that = this;

      if (that.sendCodeCD > 0) {
        return;
      }

      that.loginByMobileFormRules.code[0].required = false;
      that.$refs.loginByMobileForm.validate(function (valid, err) {
        if (valid) {
          that.sendCodeLoading = true;
          sendCode({
            mobile: that.loginByMobileForm.username,
            event: 'dealer'
          }).then(function (res) {
            that.sendCodeCD = 60;
            that.sendSmsCodeCD();
            that.$message.success('发送成功，请注意查收短信码');
          }).finally(function () {
            that.sendCodeLoading = false;
          });
        } else {// 登录表单校验失败
        }
      });
    },
    sendSmsCodeCD: function sendSmsCodeCD() {
      var that = this;

      if (that.sendCodeCD > 0) {
        that.sendCodeCD = that.sendCodeCD - 1;
        setTimeout(function () {
          that.sendSmsCodeCD();
        }, 1000);
      } else {
        that.sendCodeCD = 0;
      }
    },
    goBack: function goBack() {
      var that = this;
      that.pageId = 'login';
    },
    logOut: function logOut() {
      var that = this;
      that.logout({
        confirm: false
      });
      that.pageId = 'login';
      that.loginStatus = false;
    },
    selectOrganizations: function selectOrganizations() {
      var that = this;
      that.loadOrganization();
      that.pageId = 'organizations';
    },
    forgetPassword: function forgetPassword() {
      var that = this;
      that.$refs.ForgetPasswordComponents.init();
    },
    updateUsernameByPassword: function updateUsernameByPassword(username) {
      var that = this;
      that.loginByMobileForm.username = username;
    },
    updateUsernameByMobile: function updateUsernameByMobile(username) {
      var that = this;
      that.loginByPasswordForm.username = username;
    }
  })
};